export default "__VITE_ASSET__BChF45yY__"